import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PortfolioList } from './portfolio-list/PortfolioList';
import * as Scroll from 'react-scroll';

export class Portfolio extends React.Component<{}, {}> {

  render() {
    return (
      <section  id="portfolio-section">
        <Scroll.Element name="portfolio">
          <Container fluid tag="article" className="p-0">
            <header className="section-header">
              <Row>
                <Col xs="12 py-5">
                  <h1>Töitämme</h1>
                </Col>
              </Row>
            </header>
            <PortfolioList/>
          </Container>
        </Scroll.Element>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/portfolio/Portfolio.tsx